import { QueryClient } from '@tanstack/react-query';
import type { ApiError } from './api.js';

// Register ApiError as TanStack Query's default error type — so every useQuery
// hook downstream sees `query.error` typed as ApiError without a per-call generic.
declare module '@tanstack/react-query' {
  interface Register {
    defaultError: ApiError;
  }
}

/**
 * TanStack Query client tuned for mobile field use.
 *
 * - staleTime 30s: limits chatter while moving around the app
 * - gcTime 5min: keeps caches around long enough for back-navigation
 * - networkMode 'offlineFirst': queries return cached data immediately even when offline
 * - retry: only retry once on network failure (the app should surface "tap to retry")
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        retry: 1,
        refetchOnWindowFocus: false,
        networkMode: 'offlineFirst',
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
